export const GetUnPaidInvoices = (api, custId, dateFrom, dateTo) => {
   var filters = {
      custId: custId,
      DateFrom: dateFrom.length > 0 ? dateFrom : null,
      DateTo: dateTo.length > 0 ? dateTo : null,
   }
   return api.post(`/api/v1/Invoice/GetUnPaidInvoices?custId`, filters)
}

export const GetArchiveInvoices = (api, custId, dateFrom, dateTo) => {
   var filters = {
      custId: custId,
      DateFrom: dateFrom.length > 0 ? dateFrom : null,
      DateTo: dateTo.length > 0 ? dateTo : null,
   }
   return api.post('/api/v1/Invoice/GetArchiveInvoices', filters)
}

export const GetArchiveInvoiceItems = (api, invoiceNumber, date, siteId) => {
   var filters = {
      InvoiceNumber: invoiceNumber,
      Date: date,
      SiteId: siteId,
   }
   return api.post('/api/v1/Invoice/GetArchiveInvoiceItems', filters)
}

export const GetDatesOptions = (api) => {
   return api.get("/api/v1/Invoice/GetTables")
}

export const GetDocumentPdf = (api, docNo, docDate, siteId) => {
   return api.get(`/api/v1/Invoice/GetDocumentPdf`, {
      params: {
         docNo: docNo,
         docDate: docDate,
         siteId: siteId
      },
      responseType: 'blob'
   })
}
